import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { format } from '../../shared/utils/string.util';
import { LakehouseLinkedService } from '../linkedservice/lakehouse.linkedservice';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.lakehouseTableDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.LakehouseTable_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.LakehouseTable_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: LakehouseLinkedService.MODEL // Linked service redefined
        }
    }
})
export class LakehouseTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
